/**
 * Ad Performance — per-source funnel (lead -> booked -> deal) from
 * GET /api/leads/attribution. Spend / CPL / ROI columns land with Phase 4
 * (Google Ads API pull). See the ads-attribution spec (2026-06-30).
 */
import { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3001';
const pct = (r) => `${Math.round((r || 0) * 100)}%`;

export default function AdPerformanceView() {
  const { authFetch } = useAuth();
  const [rows, setRows] = useState(null);

  useEffect(() => {
    authFetch(`${API_BASE}/api/leads/attribution`)
      .then((r) => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then((d) => setRows(d.success && Array.isArray(d.data) ? d.data : []))
      .catch(() => setRows([]));
  }, [authFetch]);

  if (rows === null) return <div className="ws-pulse">Loading…</div>;
  if (rows.length === 0) return (
    <div className="sol-empty">
      <h3>No attributed leads yet</h3>
      <p>This fills in as the funnel takes traffic.</p>
    </div>
  );

  return (
    <div>
      <p className="ws-empty">Per-source funnel. Spend / cost-per-lead / ROI arrive with the Google Ads API pull (Phase 4).</p>
      <div className="ws-table ad-perf-table" style={{ marginTop: 14 }}>
        <div className="ws-row ws-row--head">
          <span>Source</span><span>Leads</span><span>Booked</span><span>Deals</span><span>Book %</span><span>Deal %</span>
        </div>
        {rows.map((r) => (
          <div key={r.source} className="ws-row">
            <span>{r.source}</span>
            <span>{r.total}</span>
            <span>{r.booked}</span>
            <span>{r.deals}</span>
            <span>{pct(r.bookedRate)}</span>
            <span>{pct(r.dealRate)}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
